import { useState } from "react";
import emailjs from "@emailjs/browser";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";

const useForm = () => {
  const [sendMessage, setSendMessage] = useState(false);
  const [error, setError] = useState(false);
  const [t] = useTranslation("global");
  const [spinner, setSpinner] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      company: "",
      email: "",
      message: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.name) {
        errors.name = t("errorName.errorName");
      }
      if (!values.company) {
        errors.company = t("errorCompany.errorCompany");
      }

      if (!values.email) {
        errors.email = t("emailError.emailError");
      } else if (
        !/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.([a-zA-Z0-9-.]{2,3})+$/.test(
          values.email
        )
      ) {
        errors.email = t("ErrorEmail.ErrorEmail");
      }
      if (!values.message) {
        errors.message = t("errorMessage.errorMessage");
      }
      return errors;
    },

    onSubmit: (values, { resetForm }) => {
      setSpinner(true);

      emailjs
        .send(
          process.env.REACT_APP_SERVICE_KEY,
          process.env.REACT_APP_TEMPLATE_KEY,
          values,
          process.env.REACT_APP_USER_KEY
        )
        .then(
          (result) => {
            setSendMessage(true);
            setSpinner(false);
          },
          (error) => {
            setError(true);
            setSpinner(false);
          }
        );

      setTimeout(() => {
        resetForm();
      }, 3000);
    },
  });
  return {
    formik,
    sendMessage,
    error,
    setSendMessage,
    setError,

    spinner,
  };
};

export default useForm;
